'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import Chapter from 'academy-shared-js/records/Chapter';
import Exam from 'academy-shared-js/records/Exam';
import { ExamScreen } from '../features/exams';
import Quiz from 'academy-shared-js/records/Quiz';
import { Quiz as QuizContainer } from '../features/quiz';
import PracticalExercise from 'academy-shared-js/records/PracticalExercise';
import Video from 'academy-shared-js/records/Video';
import Link from 'academy-shared-js/records/Link';
import StoredVideoWithControls from '../components/video/StoredVideoWithControls';
import MissingContentError from '../components/Errors/MissingContentError';
import PropTypes from 'prop-types';
import LinkContentContainer from './LinkContentContainer';
import ChapterContainer from './Chapter/ChapterContainer';
import { PracticalExercise as PracticalExerciseContainer } from '../features/practicalExercise';
import { getTracksAreRequesting, getTrackByIdIsLoading } from '../selectors/trackSelectors';

const LoadingPE = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  grow: true,
  minHeight: 400
});

const StoredContentContainer = ({
  contentId,
  content,
  isParentGraded,
  isRequesting,
  lessonId,
  lessonName,
  trackId,
  trackName,
  onFinish
}) => {
  let ChildComponent = () => null;

  let notFoundError = false;

  if (content instanceof Quiz) {
    ChildComponent = QuizContainer;
  } else if (content instanceof Video) {
    ChildComponent = StoredVideoWithControls;
  } else if (content instanceof PracticalExercise) {
    ChildComponent = PracticalExerciseContainer;
  } else if (content instanceof Link) {
    ChildComponent = LinkContentContainer;
  } else if (content instanceof Exam) {
    ChildComponent = ExamScreen;
  } else if (content instanceof Chapter) {
    ChildComponent = ChapterContainer;
  } else if (!content) {
    notFoundError = true;
  }

  if (notFoundError) {
    if (isRequesting) {
      return /*#__PURE__*/_jsx(LoadingPE, {});
    }

    return /*#__PURE__*/_jsx(MissingContentError, {});
  }

  return /*#__PURE__*/_jsx("div", {
    className: "stored-content-container",
    "data-contentid": contentId // used for testing
    ,
    "data-test-content-requesting": isRequesting,
    "data-test-id": "stored-content-container",
    children: /*#__PURE__*/_jsx(ChildComponent, {
      contentId: contentId,
      isParentGraded: isParentGraded,
      lessonId: lessonId,
      lessonName: lessonName,
      onFinish: onFinish,
      trackId: trackId,
      trackName: trackName
    })
  });
};

StoredContentContainer.propTypes = {
  content: PropTypes.object.isRequired,
  contentId: PropTypes.string.isRequired,
  isParentGraded: PropTypes.bool,
  isRequesting: PropTypes.bool,
  lessonId: PropTypes.string,
  lessonName: PropTypes.string,
  onFinish: PropTypes.func,
  trackId: PropTypes.string,
  trackName: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  const {
    contentId
  } = ownProps;
  const {
    contentById
  } = state;
  const content = contentById.get(contentId);
  let isRequesting = ownProps.isRequesting;

  if (!Object.keys(ownProps).includes('isRequesting')) {
    isRequesting = getTracksAreRequesting(state) || getTrackByIdIsLoading(state);
  }

  return {
    content,
    isRequesting
  };
}

export default connect(mapStateToProps)(StoredContentContainer);